// The browser tab. The static page names nobody: another firm must not flash
// Provey's title or its P before the account is known, and Provey's own tab
// is put back once we know it is Provey.
const asset = (path) => `${process.env.PUBLIC_URL || ""}${path}`;

const dropIcons = () => {
  document.head.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"], link[rel="manifest"]')
    .forEach(el => el.remove());
};

export function applyFirmTab(firm, { matter = "" } = {}) {
  const other = Boolean(firm && firm.isDefault === false);
  const brand = other ? (String(firm.name || "").trim() || "Portal") : "Provey";
  document.title = matter ? `${matter} — ${brand}` : brand;
  dropIcons();
  if (other) {
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = "data:,";
    document.head.appendChild(link);
    return;
  }
  const icon = document.createElement("link");
  icon.rel = "icon";
  icon.href = asset("/favicon.ico");
  icon.sizes = "any";
  document.head.appendChild(icon);
  const apple = document.createElement("link");
  apple.rel = "apple-touch-icon";
  apple.href = asset("/apple-touch-icon.png");
  document.head.appendChild(apple);
  const manifest = document.createElement("link");
  manifest.rel = "manifest";
  manifest.href = asset("/manifest.json");
  document.head.appendChild(manifest);
}
